import { render, staticRenderFns } from "./MPSelect.vue?vue&type=template&id=90d10782&scoped=true&"
import script from "./MPSelect.vue?vue&type=script&lang=js&"
export * from "./MPSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d10782",
  null
  
)

export default component.exports